/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalEhrDocument } from './ExternalEhrDocument';
import {
    ExternalEhrDocumentFromJSON,
    ExternalEhrDocumentFromJSONTyped,
    ExternalEhrDocumentToJSON,
    ExternalEhrDocumentToJSONTyped,
} from './ExternalEhrDocument';

/**
 * 
 * @export
 * @interface ScreenerAdditionalDocument
 */
export interface ScreenerAdditionalDocument {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    s3_key: string;
    /**
     * 
     */
    created_at?: string;
    /**
     * 
     */
    content_type?: string;
    /**
     * 
     */
    filesize_in_bytes?: number;
    /**
     * 
     */
    page_count?: number;
    /**
     * 
     */
    s3_access_url?: string;
    /**
     * 
     */
    external_ehr_document?: ExternalEhrDocument;
    /**
     * 
     */
    combined_from_lead_id?: string;
}

/**
 * Check if a given object implements the ScreenerAdditionalDocument interface.
 */
export function instanceOfScreenerAdditionalDocument(value: object): value is ScreenerAdditionalDocument {
    if (!('s3_key' in value) || value['s3_key'] === undefined) return false;
    return true;
}

export function ScreenerAdditionalDocumentFromJSON(json: any): ScreenerAdditionalDocument {
    return ScreenerAdditionalDocumentFromJSONTyped(json, false);
}

export function ScreenerAdditionalDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerAdditionalDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'name': json['name'] == null ? undefined : json['name'],
        's3_key': json['s3_key'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
        'content_type': json['content_type'] == null ? undefined : json['content_type'],
        'filesize_in_bytes': json['filesize_in_bytes'] == null ? undefined : json['filesize_in_bytes'],
        'page_count': json['page_count'] == null ? undefined : json['page_count'],
        's3_access_url': json['s3_access_url'] == null ? undefined : json['s3_access_url'],
        'external_ehr_document': json['external_ehr_document'] == null ? undefined : ExternalEhrDocumentFromJSON(json['external_ehr_document']),
        'combined_from_lead_id': json['combined_from_lead_id'] == null ? undefined : json['combined_from_lead_id'],
    };
}

export function ScreenerAdditionalDocumentToJSON(json: any): ScreenerAdditionalDocument {
    return ScreenerAdditionalDocumentToJSONTyped(json, false);
}

export function ScreenerAdditionalDocumentToJSONTyped(value?: ScreenerAdditionalDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'name': value['name'],
        's3_key': value['s3_key'],
        'created_at': value['created_at'],
        'content_type': value['content_type'],
        'filesize_in_bytes': value['filesize_in_bytes'],
        'page_count': value['page_count'],
        's3_access_url': value['s3_access_url'],
        'external_ehr_document': ExternalEhrDocumentToJSON(value['external_ehr_document']),
        'combined_from_lead_id': value['combined_from_lead_id'],
    };
}

